import React from "react"

import { Button, OverlayTrigger, Popover } from "react-bootstrap"

import TrendColorEditor from "../../plotting/widgets/TrendEditorPopover/TrendColorEditor"
import DropdownTrendField from "./DropdownTrendField"
import InputTrendField from "./InputTrendField"
import { registration } from "./index"

export const trendFields = {
  tag: { editable: false, type: "text" },
  units: { editable: false, type: "text" },
  label: { editable: true, type: "text" },
  colour: { editable: true, type: "color" },
  style: {
    editable: true,
    type: "dropdown",
    options: ["line", "linespoints", "points"],
    optionsRename: { linespoints: "both" },
    defaultValue: "points",
  },
  strokeWidth: { editable: true, type: "intBox" },
  strokeModifier: {
    editable: true,
    type: "dropdown",
    options: ["solid", "dashed"],
    defaultValue: "solid",
  },
  pointSize: { editable: true, type: "intBox" },
  pointModifier: {
    editable: true,
    type: "dropdown",
    options: ["points", "triangle"],
    defaultValue: "points",
  },
  axis2: { editable: true, type: "checkbox" },
  disabled: { editable: true, type: "checkbox" },
}

export default function GraphFieldTable({ update_field, disabled, graph_value, intl }) {
  return (
    <table className={"table table-condensed tbl_lanzatable"}>
      <thead>
        <tr>
          {(Object.keys(trendFields) || []).map((field, idx) => {
            const field_name = registration[`${field}_trend_field`](intl)
            return (
              <th key={`${field}_${idx}`} className={"text-center"}>
                {field_name}
                {field === "axis2" ? "2?" : ""}
              </th>
            )
          })}
        </tr>
      </thead>
      <tbody>
        {graph_value.map((obv, idx) => (
          <tr key={`obv_row${idx}`}>
            {(Object.keys(trendFields) || []).map((field, i) => {
              let cell_value = "-"
              const obv_info = trendFields[field]
              const is_disabled = !obv_info.editable || disabled
              const obv_type = obv_info.type
              if (obv_type === "text") {
                cell_value = !is_disabled ? (
                  <input
                    type={"text"}
                    disabled={!obv_info.editable || disabled}
                    value={obv[field] || ""}
                    onChange={(ev) => {
                      ev.preventDefault()
                      update_field(ev.target.value, idx, field)
                    }}
                  />
                ) : (
                  <span>{obv[field] || ""}</span>
                )
              } else if (obv_type === "intBox") {
                cell_value = (
                  <InputTrendField
                    obv={obv}
                    field={field}
                    width={"50px"}
                    disabled={disabled}
                    updateField={(opt) => update_field(opt, idx, field)}
                  />
                )
              } else if (obv_type === "dropdown") {
                cell_value = (
                  <DropdownTrendField
                    obv={obv}
                    field={field}
                    intl={intl}
                    disabled={disabled}
                    updateField={(opt) => update_field(opt, idx, field)}
                  />
                )
              } else if (obv_type === "checkbox") {
                const is_disabled =
                  (["axis2", "disabled"].includes(field) &&
                    (obv.style === "box" || ["Design", "Total Production"].includes(obv.tag))) ||
                  disabled
                const checked = obv[field] || false

                cell_value = !is_disabled ? (
                  <input
                    type={"checkbox"}
                    key={Math.random()} // To force rerender of checkbox on change
                    checked={checked}
                    disabled={is_disabled}
                    onChange={(ev) => {
                      ev.preventDefault()
                      update_field(!obv[field], idx, field)
                    }}
                  />
                ) : (
                  <span className={`fa ${checked ? "fa-check-circle-o" : "fa-times-circle-o"}`} />
                )
              } else if (obv_type === "color") {
                const color_square = (
                  <svg width={25} height={25}>
                    <rect
                      key={idx}
                      x={0}
                      y={0}
                      width={25}
                      height={25}
                      style={{ strokeWidth: "2", fill: obv[field] }}
                    />
                  </svg>
                )
                cell_value = !disabled ? (
                  <OverlayTrigger
                    trigger={"click"}
                    placement={"left"}
                    rootClose
                    overlay={
                      <Popover id={"colorPicker"}>
                        <Popover.Header as={"h3"}>{registration["choose_trend_color"](intl)}</Popover.Header>
                        <Popover.Body>
                          <TrendColorEditor
                            intl={intl}
                            colorSelect={(color) => update_field(color, idx, field)}
                            rowStyle={{ marginBottom: "15px", display: "flex" }}
                          />
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <Button variant={"outline-primary"} disabled={disabled}>
                      {color_square}
                    </Button>
                  </OverlayTrigger>
                ) : (
                  <>{color_square}</>
                )
              }

              return (
                <td key={`obv_row${idx}_col${i}`} className={"text-center"}>
                  {cell_value}
                </td>
              )
            })}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
